import { Helmet } from 'react-helmet-async';
import { Phone } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PflegeZuhauseVsPflegeheim() {
  return (
    <>
      <Helmet>
        <title>Pflege zuhause oder Pflegeheim? Ehrlicher Vergleich</title>
        <meta name="description" content="Pflege zuhause vs Pflegeheim - Ehrlicher Vergleich für Itzehoe" />
      </Helmet>

      <main className="pt-32 pb-20">
        <div className="container-custom max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-[#1e293b] mb-6 text-center">
            Pflege zuhause oder Pflegeheim?
          </h1>
          
          <div className="bg-white rounded-xl p-8 border border-[#e2e8f0] mb-8">
            <h2 className="text-2xl font-bold text-[#1e293b] mb-4">Unsere ehrliche Empfehlung</h2>
            <p className="text-[#64748b] mb-4">
              Probieren Sie erst Pflege zuhause. In 70% der Fälle funktioniert es gut.
            </p>
            <p className="text-[#64748b]">
              Wenn es nicht klappt, ist Heim keine Schande. Wir sagen Ihnen ehrlich unsere Meinung.
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#1A52D8] to-[#23D3D3] rounded-xl p-8 text-center text-white">
            <h3 className="text-2xl font-bold mb-4">Lassen Sie uns Ihre Situation besprechen</h3>
            <p className="text-lg mb-6">Kostenlos, ehrlich, ohne Druck.</p>
            <a href="tel:+4915146173685">
              <Button className="bg-white text-[#1A52D8] hover:bg-white/90 h-12 px-8 rounded-full font-semibold">
                <Phone className="w-5 h-5" />
                Jetzt Anrufen: 0151 46173685
              </Button>
            </a>
          </div>
        </div>
      </main>
    </>
  );
}
